import SpinnerLoader from "@/components/SpinnerLoader.jsx";
import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<SpinnerLoader />}>
      <Component {...props} />
    </Suspense>
  );

const SportsGroundBookingScreen = Loadable(
  lazy(() => import("./SportsGroundBookingScreen/index.jsx"))
);
const SportsGroundListing = Loadable(
  lazy(() => import("./SportsGroundListing/index.jsx"))
);
const SportsDetail = Loadable(lazy(() => import("./SportsDetail/index.jsx")));
const SportsSlotBook = Loadable(
  lazy(() => import("./SportsSlotBook/index.jsx"))
);
const BookingSummary = Loadable(
  lazy(() => import("./BookingSummary/index.jsx"))
);
const SportsSelect = Loadable(lazy(() => import("./SportsSelect/index.jsx")));
const GroundBookingConfirm = Loadable(
  lazy(() => import("./GroundBookingConfirm/index.jsx"))
);

const sportsRoutes = [
  {
    path: "sports",
    children: [
      {
        index: true,
        element: <Navigate to="9" replace />,
      },
      {
        path: ":category_id",
        element: (
          <Suspense fallback={<SpinnerLoader />}>
            <SportsGroundBookingScreen />
          </Suspense>
        ),
      },
      {
        path: "ground-listing/:category_id",
        element: (
          <Suspense fallback={<SpinnerLoader />}>
            <SportsGroundListing />
          </Suspense>
        ),
      },
      {
        path: "provider-detail/:provider_id",
        element: (
          <Suspense fallback={<SpinnerLoader />}>
            <SportsDetail />
          </Suspense>
        ),
      },
      {
        path: "slot-book",
        element: (
          <Suspense fallback={<SpinnerLoader />}>
            <SportsSlotBook />
          </Suspense>
        ),
      },
      {
        path: "booking-summary",
        element: (
          <Suspense fallback={<SpinnerLoader />}>
            <BookingSummary />
          </Suspense>
        ),
      },
      {
        path: "service-select",
        element: (
          <Suspense fallback={<SpinnerLoader />}>
            <SportsSelect />
          </Suspense>
        ),
      },
      {
        path: "booking-confirm",
        element: (
          <Suspense fallback={<SpinnerLoader />}>
            <GroundBookingConfirm />
          </Suspense>
        ),
      },
    ],
  },
];

export default sportsRoutes;
   
